// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { kpiFormulaId } from './KpiFormula';
import { operatorId } from './Operator';
import { z } from 'zod';
export const kpiFormulaAuditId = (z.string());
export const kpiFormulaAudit = z.object({
    id: kpiFormulaAuditId,
    formula_id: kpiFormulaId,
    before_state: z.unknown().nullable(),
    after_state: z.unknown(),
    change_type: z.string(),
    changed_at: z.date().nullable(),
    changed_by: operatorId.nullable(),
});
export const kpiFormulaAuditInitializer = z.object({
    id: kpiFormulaAuditId.optional(),
    formula_id: kpiFormulaId,
    before_state: z.unknown().optional().nullable(),
    after_state: z.unknown(),
    change_type: z.string(),
    changed_at: z.date().optional().nullable(),
    changed_by: operatorId.optional().nullable(),
});
export const kpiFormulaAuditMutator = z.object({
    id: kpiFormulaAuditId.optional(),
    formula_id: kpiFormulaId.optional(),
    before_state: z.unknown().optional().nullable(),
    after_state: z.unknown().optional(),
    change_type: z.string().optional(),
    changed_at: z.date().optional().nullable(),
    changed_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=KpiFormulaAudit.js.map